import React from "react";

export interface LabelProps
  extends React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  > {}

const Label: React.FC<LabelProps> = ({ ...props }) => (
  <label className="fl-text-sm fl-opacity-75 fl-text-dark" {...props} />
);

export default Label;
